'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { DefaultsContext, InternalProvider, usePropValueDeprecation } from '../../util';
import { StyledTag, TagIconWrapper, TextWrapper } from './elements';
import { Icon } from '../Icon';
export const Tag = /*#__PURE__*/React.forwardRef(({
  text,
  type = 'gray',
  size,
  iconSrc,
  truncateText,
  family = 'bold',
  ...rest
}, fRef) => {
  const {
    tagSize
  } = React.useContext(DefaultsContext);
  size ??= tagSize ?? 'regular';
  usePropValueDeprecation({
    component: 'Tag',
    prop: 'type',
    currentValue: type,
    deprecatedValues: ['attention', 'disabled', 'update'],
    version: 'v5.0.0'
  });
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(StyledTag, _extends({
    "data-aui": "tag",
    type: type,
    size: size,
    truncateText: truncateText,
    ref: fRef,
    family: family
  }, rest), iconSrc && /*#__PURE__*/React.createElement(TagIconWrapper, {
    $size: size
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    "data-testid": iconSrc,
    src: iconSrc,
    size: size === 'large' ? 'normal' : 'xsmall',
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement(TextWrapper, null, text)));
});